// extracted by mini-css-extract-plugin
module.exports = {"filter-component-list":"style_filter-component-list__OCY2C","margin-top-bottom":"style_margin-top-bottom__2zSQU"};